export const numberOfDaysInMonth = (month: number): number => {
  if (month === 2) {
    return 29;
  }
  if ([1, 3, 5, 7, 8, 10, 12].includes(month)) {
    return 31;
  }
  return 30;
};
